import React from 'react';
import { IconTooltip } from './IconTooltip';

export const ManualApprovalTooltip = () => (
  <IconTooltip iconName="checkmark" label="Manually Approved" />
);
